<template>
  <div>{{cost}}</div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: 'ColumnProductCostPrice',
  props: {
    rowId: {
      type: [Number, String],
      required: true
    }
  },
  created () {
    const product = this.product(this.rowId)
    this.cost = product.costPrice || 0
    this.bus.$on(`product-selected-${this.rowId}`, (product) => this.cost = product.costPrice)
  },
  beforeDestroy () {
    this.bus.$off(`product-selected-${this.rowId}`)
  },
  data () {
    return {
      cost: 0
    }
  },
  computed: {
    ...mapGetters({
      product: 'edit/lineProduct'
    })
  },
  inject: ['bus']
}
</script>
